import React, { Fragment, useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { Spin, Tag } from 'antd';
import cloneDeep from 'lodash.clonedeep';
// import axios from 'axios';
import { connect } from 'react-redux';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import ReactEcharts from '../../Echarts/Echarts';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';
// import localStorage from '../../../../../utils/localStorage';
import { sliderstatus } from '../../../Mock/MockJson';
import { config } from '../../constant';

const SliderStatus = (props) => {

  const [option, setOption] = useState({});
  const [loading] = useState(false);
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const [, setVisualAMpArray] = useState([]);

  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);

  let theme = props.selectedThemeing;

  const getData = async (props) => {
    let theme = props.selectedThemeing;
    requestCheck.current = false;
    setErrorInAPI(false);
    setNoDataInDB(false);
    let json = [];
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = sliderstatus;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      let visualMap = {};
      let dates = [];
      let values = [];
      let name = '';
      let tagnames = [];
      let seriesarray = [];
      let legendsdata = [];
      json &&
        Array.isArray(json) &&
        json.map((val) => {
          if (val.Name !== name) {
            if (tagnames.indexOf(val.Name) === -1) {
              tagnames.push(val.Name);
              name = val.Description;
              legendsdata.push({
                name: val.Description,
                icon: 'roundRect',
                textStyle: {
                  color: theme === 'lightTheme' ? 'black' : 'white',
                  fontSize: 16,
                  fontWeight: 'bold'
                }
              });
            }
          }
          return {};
        });

      let yAxisData = [];

      if (props &&
        props.graphprops &&
        props.graphprops.sliderStatus &&
        props.graphprops.sliderStatus.YAxis &&
        JSON.parse(props.graphprops.sliderStatus.YAxis)
      ) {
        let data = props &&
          props.graphprops &&
          props.graphprops.sliderStatus &&
          props.graphprops.sliderStatus.YAxis;
        yAxisData = JSON.parse(data);
      }

      let yaxis = yAxisData.map((value) => {
        let axis = {};
        axis.splitLine = {
          show: true,
          lineStyle: {
            color: '#504c4c'
          },
          axisLabel: { fontSize: 15 }
        };
        axis.triggerEvent = true;
        axis.axisLine = {
          lineStyle: {
            color: 'white'
            // color:
            //   this.props.graphprops.colors[index] !== undefined
            //     ? value && value.tags && value.tags.length > 1
            //       ? "white"
            //       : this.props.graphprops.colors[index]
            //     : "white",
          },
          axisLabel: { fontSize: 12 }
        };
        axis.max = value.max;
        axis.min = value.min;
        axis.offset = value.offset;
        axis.interval = value.interval;
        axis.position = value.position;
        axis.name = value.name;
        // axis.tags = value.tags;
        return axis;
      });

      yaxis.unshift({
        splitLine: {
          show: true,
          lineStyle: {
            color: '#504c4c'
          }
        },
        triggerEvent: true,
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: { fontSize: 15 },
        tags: []
      });

      tagnames.map((tagval, tagindex) => {
        values = [];
        let array = [
          {
            lte: 0,
            color: 'Green'
          }
        ];
        let linetags = props &&
          props.graphprops &&
          props.graphprops.sliderStatus &&
          props.graphprops.sliderStatus.tags
          ? props.graphprops.sliderStatus.tags
          : [];
        json.map((jsonval) => {
          if (tagnames[0] === jsonval.Name && tagindex === 0) {
            let date =
              graphprops && graphprops.type === 'live'
                ? moment.utc(jsonval.DateTime).local().format('YYYY-MM-DD HH:mm:ss')
                : moment(jsonval.DateTime).format('YYYY-MM-DD HH:mm:ss');
            dates.push(date);
          }
          if (tagval === jsonval.Name) {
            values.push(jsonval.Value);
          }
          if (jsonval.Name === tagnames[0]) {
            if (jsonval && jsonval.GT && jsonval.LTE && jsonval.Color !== undefined)
              array.push({
                gt: Number(jsonval.GT),
                lte: Number(jsonval.LTE),
                color: jsonval.Color
              });
            //  let test = array[array.length-1];
            //  delete test.lte;
            //  array.push(test);

            setVisualAMpArray(array);
            visualMap = {
              show: false,
              dimension: 0,
              seriesIndex: 0,
              pieces: array,
              textStyle: {
                color: 'white'
              }
            };
          }
          return {};
        });
        if (props && props.graphprops && props.graphprops.linetype === 'area') {
          if (yaxis.length > 1) {
            yaxis.map((axis, axisindex) => {
              if (axis.tags.indexOf(tagval) !== -1) {
                let linetags = props && props.graphprops && props.graphprops.sliderStatus && props.graphprops.sliderStatus.tags ? props.graphprops.sliderStatus.tags : [];
                if (linetags && linetags.length > 0) {
                  linetags &&
                    linetags.map((tag) => {
                      seriesarray.push({
                        type: legendsdata[tagindex]['name'] !== tag ? 'bar' : 'bar',
                        name: legendsdata[tagindex]['name'],
                        data: values,
                        axisLabel: { fontSize: 15 },
                        yAxisIndex: axisindex,
                        areaStyle: {},
                        smooth: true
                      });
                      return {};
                    });
                } else {
                  seriesarray.push({
                    type: 'bar',
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    axisLabel: { fontSize: 15 },
                    yAxisIndex: axisindex,
                    areaStyle: {},
                    smooth: true
                  });
                }
              }
              return {};
            });
          } else {
            let linetags = props && props.graphprops && props.graphprops.sliderStatus && props.graphprops.sliderStatus.tags ? props.graphprops.sliderStatus.tags : [];
            if (linetags && linetags.length > 0) {
              linetags &&
                linetags.map((tag) => {
                  seriesarray.push({
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    type: legendsdata[tagindex]['name'] !== tag ? 'bar' : 'bar',
                    axisLabel: { fontSize: 15 },
                    areaStyle: {},
                    smooth: true
                  });
                  return {};
                });
            } else {
              seriesarray.push({
                name: legendsdata[tagindex]['name'],
                data: values,
                type: 'bar',
                axisLabel: { fontSize: 15 },
                areaStyle: {},
                smooth: true
              });
            }
          }
        } else {
          if (yaxis.length > 1) {
            yaxis.map((axis, axisindex) => {
              if (axis && axis.tags && axis.tags.indexOf(tagval) === -1) {
                let linetags = props &&
                  props.graphprops &&
                  props.graphprops.sliderStatus &&
                  props.graphprops.sliderStatus
                  ? props.graphprops.sliderStatus.tags
                  : [];
                if (linetags && linetags.length > 0) {
                  linetags &&
                    linetags.map((tag) => {
                      seriesarray.push({
                        name: legendsdata[tagindex]['name'],
                        data: values,
                        yAxisIndex: axisindex,
                        type: legendsdata[tagindex]['name'] !== tag ? 'bar' : 'line',
                        axisLabel: { fontSize: 16 }
                      });
                      return {};
                    });
                } else {
                  seriesarray.push({
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    yAxisIndex: axisindex,
                    type: 'bar',
                    axisLabel: { fontSize: 15 }
                  });
                }
              }
              return {};
            });
          } else {
            if (linetags && linetags.length > 0) {
              linetags &&
                linetags.map((tag) => {
                  seriesarray.push({
                    markArea: {
                      itemStyle: {
                        color: 'rgba(255, 173, 177, 0.4)'
                      }
                    },
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    type: legendsdata[tagindex]['name'] !== tag ? 'bar' : 'bar',
                    axisLabel: { fontSize: 15 }
                  });
                  return {};
                });
            } else {
              let colorData = props && props.graphprops && props.graphprops.sliderStatus && props.graphprops.sliderStatus.colors[0]
                ? props.graphprops.sliderStatus.colors[0] : '';
              seriesarray.push({
                name: legendsdata[tagindex]['name'],
                data: values,
                type: 'bar',
                color: colorData,
                axisLabel: { fontSize: 15 }
              });
            }
          }
        }
        return {};
      });
      const option = cloneDeep(getOption());
      if (props && props.graphprops && props.graphprops.sliderStatus &&
        props.graphprops.sliderStatus.linecolor &&
        props.graphprops.sliderStatus.linecolor.length > 0
      ) {
        option.color = [...props.graphprops.sliderStatus.linecolor];
      }
      let series = await trendLabelTranslation(seriesarray, props.translationCache);
      option.xAxis.data = [...dates];
      option.yAxis = [...yaxis];
      option.series = [...series];
      option.legend = [...legendsdata];
      option.visualMap = visualMap;
      setOption(option);
      setRefreshDateTime(moment());
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  const getOption = () => {
    let theme = props.selectedThemeing;
    // let colorCode = this.props.graphprops && this.props.graphprops.colors ? this.props.graphprops.colors : ['red', "green"]
    let option = {
      title: {
        // text: 'Distribution of Electricity',
        // subtext: 'Fake Data'
      },
      // tooltip: {
      //   trigger: 'axis',
      //   // axisPointer: {
      //   //   type: 'cross'
      //   // }
      // },
      tooltip: {
        trigger: 'axis',
        // formatter: "{b} <br/>{a}: {c} <br/> {a1} : {c1}",
        formatter: function (params) {
          var colorSpan = (color) =>
            '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' +
            color +
            '"></span>';
          let rez = '<p>' + params[0].axisValue + '</p>';
          var xx = '';
          params.forEach((item, index) => {
            if (index <= 1) {
              if (item.seriesName === 'BeltSpeed(mt/sec)' && item.color === 'Red') {
                xx =
                  '<p>' +
                  colorSpan(item.color) +
                  ' ' +
                  'TransientSpeed' +
                  ': ' +
                  item.data +
                  '</p>';
              } else if (item.seriesName === 'BeltSpeed(mt/sec)' && item.color !== 'Red') {
                xx =
                  '<p>' +
                  colorSpan(item.color) +
                  ' ' +
                  'StationarySpeed' +
                  ': ' +
                  item.data +
                  '</p>';
              } else {
                xx =
                  '<p>' + colorSpan(item.color) + ' ' + item.seriesName + ': ' + item.data + '</p>';
              }

              rez += xx;
            }
          });

          return rez;
        },
        axisPointer: {
          type: 'shadow',
          animation: true
        },

        textStyle: {
          // color: theme === "lightTheme" ? "black" : "white",
          fontSize: 16
        }
      },

      toolbox: {
        show: true,
        feature: {
          saveAsImage: {
            title: 'download',
            backgroundColor: theme === 'lightTheme' ? 'white' : 'black',
            name: props.graphprops.title
          }
        }
      },
      series: [],
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLabel: {
          color: "white"
        }
        // prettier-ignore
        // data: ['00:00', '01:15', '02:30', '03:45', '05:00', '06:15', '07:30', '08:45', '10:00', '11:15', '12:30', '13:45', '15:00', '16:15', '17:30', '18:45', '20:00', '21:15', '22:30', '23:45']
      },

      // visualMap: {
      //   show: false,
      //   dimension: 0,
      //   pieces: VisualAMpArray,
      // },
      yAxis: {
        type: 'value',
        // axisLabel: {
        //     formatter: '{value} W'
        // },
        axisPointer: {
          snap: true
        }
      }
    };
    return option;
  };

  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag color="blue" style={{ float: '', position: 'relative', zIndex: '2' }}>
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}

      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <span>
          {loading === false ? (
            <ReactEcharts
              option={option}
              notMerge={true}
              lazyUpdate={true}
              style={{ height: '90%', width: '100%' }}
              className="react_for_echarts"
            />
          ) : (
            <div
              style={{
                textAlign: 'center',
                color: theme === 'lightTheme' ? 'black' : 'white',
                marginTop: '10%'
              }}
            >
              <h2 style={{ color: 'black' }}>
                <Spin spinning={loading} tip="Loading..." ></Spin>
              </h2>
            </div>
          )}
        </span>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.translationCache
  };
};


export default connect(mapStateToProps)(SliderStatus);
